import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import Login from '../../auth/login';
import Registration from '../../auth/registration';
import ChangePassword from '../../auth/changePassword';
import ForgotPassword from '../../auth/forgotPassword';
import EmailConfirmation from '../../auth/emailConfirmation';

import Header from '../header';
import MainContent from '../main';
import Records from '../main/records';
import Habitants from '../main/habitants';

import Institutions from '../main/institutions';
import InsitutionDetail from '../main/institutions/detail';
import InstitutionPersonal from '../main/institutions/personal';
import DoctorRecord from '../main/institutions/record';
import InstitutionPersonalDetail from '../main/institutions/personal-detail';
import InstitutionServices from '../main/institutions/services';
import InstitutionServiceDetail from '../main/institutions/service-detail';

import Services from '../main/services';
import ServiceDetail from '../main/services/detail';

import MedicalStaff from '../main/medical-staff';
import MedicalStaffDetail from '../main/medical-staff/detail';

import News from '../news';
import NewsDetail from '../news/detail';

import Reviews from '../main/reviews';

import About from '../about';
import InformationService from '../information-center';
import HealthManagment from '../management/router';
import Footer from '../footer';
import Page404 from 'components/page404';

import {ContentWrapper} from './components';

const mapStateToProps = state => ({
  token: state.auth.get('token')
});

const Content = ({ token }) => (
  <div>
    <Header/>
		<ContentWrapper>
			<Switch>
				<Route exact path="/" component={MainContent}/>

        <Route exact path="/login" component={token ? MainContent : Login}/>
        <Route exact path="/registration" component={token ? MainContent : Registration} />

				<Route exact path="/records" component={Records}/>
        <Route exact path="/records/:page" component={Records}/>
				<Route exact path="/habitants" component={Habitants}/>

				<Route exact path="/institutions" component={Institutions}/>
				<Route exact path="/institutions/:page" component={Institutions}/>
				<Route exact path="/institutions/detail/:id" component={InsitutionDetail}/>
				<Route exact path="/institutions/detail/:id/personal" component={InstitutionPersonal}/>
				<Route exact path="/institutions/detail/:id/personal/page:page" component={InstitutionPersonal}/>
				<Route exact path="/institutions/detail/:id/personal/:doctor" component={InstitutionPersonalDetail}/>
				<Route exact path="/institutions/detail/:id/personal/:doctor/record" component={token ? DoctorRecord : Page404}/>
				<Route exact path="/institutions/detail/:id/services" component={InstitutionServices}/>
				<Route exact path="/institutions/detail/:id/services/:page" component={InstitutionServices}/>
				<Route exact path="/institutions/detail/:id/service/:service" component={InstitutionServiceDetail}/>

				<Route exact path="/services" component={Services}/>
        <Route exact path="/services/:page" component={Services}/>
				<Route exact path="/services/detail/:id" component={ServiceDetail}/>

				<Route exact path="/medical-staff" component={MedicalStaff}/>
        <Route exact path="/medical-staff/:page" component={MedicalStaff}/>
        <Route exact path="/medical-staff/detail/:id" component={MedicalStaffDetail}/>

				<Route exact path="/news" component={News}/>
        <Route exact path="/news/:page" component={News}/>
				<Route exact path="/news/detail/:id" component={NewsDetail}/>

				<Route exact path="/about" component={About}/>
				<Route strict path="/infocenter" component={InformationService}/>
        <Route strict path="/infocenter/:page" component={InformationService}/>
				<Route strict path="/health-management" component={HealthManagment}/>

        <Route exact path="/reviews/:type" component={token ? Reviews : Page404} />

        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/change_password/:key" component={ChangePassword} />
        <Route exact path="/email_confirmation/" component={EmailConfirmation} />
        <Route path="*" component={Page404}/>
			</Switch>
			<Footer/>
		</ContentWrapper>
  </div>
)


export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./src/system/content/index.js